module.exports = __webpack_public_path__ + "static/img/living_1.0b7a745.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/living_1.jpg
// module id = qJt7
// module chunks = 3